import { Container } from '@chakra-ui/react';
import { useEffect } from 'react';
import OpenSourceBanner, { WebsiteDeprecationNotice } from '../../components/banner/OpenSourceBanner';

export default function Home() {
	useEffect(() => {
		document.title = 'AppsForChat - Reminder Bot Now Open Source';
	}, []);
	return (
		<>
			<OpenSourceBanner />
			<Container maxW={'6xl'} py={8}>
				<WebsiteDeprecationNotice />
			</Container>
		</>
	);
}
